// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"0d850183","239":"cdc7d339","453":"de5da927","455":"f1b72bd4","977":"c7befbd6"}[chunkId] + ".chunk.js";
};